import { useState } from 'react';
import { GridList, GridListTile } from '@material-ui/core';
import withWidth, { isWidthUp } from '@material-ui/core/withWidth';
import { BiExpand } from 'react-icons/bi';
import PropTypes from 'prop-types';
import ImageGalleryModal from './ImageGalleryModal';

const ImageGallery = ({ images, width, modalTitle }) => {
  const [doShowImagesModal, setDoShowImagesModal] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);

  const getGridListCols = () => {
    if (isWidthUp('md', width)) {
      return 3;
    }
    return 2;
  };

  const handleOpenImagesModal = (index) => {
    setSelectedImageIndex(index);
    setDoShowImagesModal(true);
  };

  const handleCloseImagesModal = () => {
    setDoShowImagesModal(false);
  };

  return (
    <div className="text-center">
      {images ? (
        <>
          <GridList cols={getGridListCols()}>
            {images.map((image, index) => {
              const imageUrl = image && image.url ? image.url : image;
              const imageAlt = (image && (image.caption || image.name)) || '';
              return (
                <GridListTile key={imageUrl} cols={1}>
                  {image && (image.category || image.caption) ? (
                    <div className="absolute z-10 text-white bg-black w-full text-left text-xs bg-opacity-50 pl-1 bottom-0">
                      {image.category}
                      {image.caption ? `: ${image.caption}` : undefined}
                    </div>
                  ) : (
                    <></>
                  )}
                  <button
                    type="button"
                    className="absolute top-0 left-0 m-2 z-10 bg-black bg-opacity-70 text-white cursor-pointer rounded-lg p-1"
                    title="Click to enlarge image"
                    onClick={() => handleOpenImagesModal(index)}
                  >
                    <BiExpand className="text-white text-md m-0.5" />
                  </button>
                  <img
                    src={imageUrl}
                    alt={imageAlt}
                    className="cursor-pointer"
                    onClick={() => handleOpenImagesModal(index)}
                    onKeyDown={(event) => {
                      if (event.key === 'Enter' || event.key === ' ') {
                        handleOpenImagesModal(index);
                      }
                    }}
                    role="presentation"
                  />
                </GridListTile>
              );
            })}
          </GridList>
          <ImageGalleryModal
            doShow={doShowImagesModal}
            onClose={handleCloseImagesModal}
            images={images}
            initialIndex={selectedImageIndex}
            title={modalTitle}
          />
        </>
      ) : (
        'No photos'
      )}
    </div>
  );
};

ImageGallery.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string,
      caption: PropTypes.string,
      category: PropTypes.string,
      name: PropTypes.string,
    }),
  ).isRequired,
  width: PropTypes.number.isRequired,
  modalTitle: PropTypes.string,
};

ImageGallery.defaultProps = {
  modalTitle: 'Photos',
};

export default withWidth()(ImageGallery);
